"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLpTokenPrice = exports.getStakingTokens = exports.getStakingSymbol = exports.getLPUrl = void 0;
var web3_utils_1 = require("web3-utils");
var _launchpadConstants_1 = require("../launchpadConstants");
var utils_1 = require("../shared/utils");
var getLPUrl = function (tokenAddress) {
    return "https://exchange.pancakeswap.finance/#/add/BNB/".concat(tokenAddress);
};
exports.getLPUrl = getLPUrl;
var getStakingSymbol = function (pool) {
    var _a = (0, exports.getStakingTokens)(pool), mainToken = _a[0], secondToken = _a[1];
    return secondToken
        ? "".concat(mainToken.symbol, "/").concat(secondToken.symbol)
        : mainToken.symbol;
};
exports.getStakingSymbol = getStakingSymbol;
var getStakingTokens = function (pool) {
    return Array.isArray(pool.stakeToken)
        ? pool.stakeToken
        : [pool.stakeToken, undefined];
};
exports.getStakingTokens = getStakingTokens;
/**
 * To determine the price of an LP token we need: totalValueInUsd / totalSupply
 * - total supply from pairContract.totalSupply
 * - totalValueInUsd:
 *  - token (TPAD) price in USD * reserve 1
 *  - PLUS pair token (BNB) price in USD * reserve 2
 */
function getLpTokenPrice(_a) {
    var pairContract = _a.pairContract, tokenPriceInUsd = _a.tokenPriceInUsd, getCurrencyPriceInUsd = _a.getCurrencyPriceInUsd, tokenDecimals = _a.tokenDecimals;
    return __awaiter(this, void 0, void 0, function () {
        var getPrice, price;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!tokenPriceInUsd) {
                        return [2 /*return*/, 0];
                    }
                    getPrice = function (tokensBN, currencyBN, supplyBN, currencyPriceInUsd) {
                        var tokensValue = tokensBN.muln(tokenPriceInUsd);
                        var currencyValue = currencyBN.muln(currencyPriceInUsd);
                        var totalValue = tokensValue.add(currencyValue);
                        var price = totalValue.mul(_launchpadConstants_1.DEC_NORM).div(supplyBN);
                        // debug("useLPTokenPrice.getLPPrice", toEth(price), {
                        //   address: pairContract.options.address,
                        //   tokenPriceInUsd,
                        //   currencyPriceInUsd,
                        //   tokens: toEth(tokensBN),
                        //   currency: toEth(currencyBN),
                        //   supply: toEth(supplyBN),
                        //   tokensValue: toEth(tokensValue),
                        //   currencyValue: toEth(currencyValue),
                        //   totalValue: toEth(totalValue),
                        // });
                        return (0, utils_1.toEthN)(price);
                    };
                    return [4 /*yield*/, Promise.all([
                            (0, utils_1.call)(pairContract, "getReserves"),
                            (0, utils_1.call)(pairContract, "totalSupply"),
                            getCurrencyPriceInUsd(),
                        ])
                            .then(function (_a) {
                            var reserves = _a[0], totalSupply = _a[1], currencyPriceInUsd = _a[2];
                            var tokensBN = (0, utils_1.normalizeDecimals)((0, web3_utils_1.toBN)(reserves["_reserve0"]), tokenDecimals);
                            var currencyBN = (0, web3_utils_1.toBN)(reserves["_reserve1"]);
                            var supplyBN = (0, web3_utils_1.toBN)(totalSupply);
                            return getPrice(tokensBN, currencyBN, supplyBN, currencyPriceInUsd);
                        })
                            .catch(function (e) {
                            console.error("Failed to determine LP Token price", e);
                            return 0;
                        })];
                case 1:
                    price = _b.sent();
                    return [2 /*return*/, price];
            }
        });
    });
}
exports.getLpTokenPrice = getLpTokenPrice;
